// import "./senja";
import { Navigate, Route, Routes, useLocation, useSearchParams } from "react-router-dom";
import { PrivateRoute } from "common/PrivateRoute";
import GlobalStyle from "styles/GlobalStyles";
import { Suspense, useEffect, lazy } from "react";
import Toast from "common/Toast";
import { useAppSelector, useTypedDispatch } from "store/hooks";
import { ThemeProvider } from "styled-components";
import theme from "styles/theme";
import ScrollToTop from "common/ScrollToTop";
import { /*MOBILE_ROUTES,*/ Pages, pagesList } from "routes";

const Home = lazy(() => import("Pages/Home"));
const RegistrationAndLogin = lazy(() => import("Pages/Authentication/RegistrationAndLogin"));
const NewPayments = lazy(() => import("Pages/NewPayments"));
const LegalTerms = lazy(() => import("Pages/LegalTerms"));
const PrivacyPolicy = lazy(() => import("Pages/PrivacyPolicy"));
const KYCVerification = lazy(() => import("Pages/KYC"));
const MyWill = lazy(() => import("Pages/MyWill/NewMyWill"));
const ShippingFlow = lazy(() => import("Pages/MyWill/ShippingFlow"));
const OnBoarding = lazy(() => import("Pages/Authentication/OnBoarding"));
const YellowPlusPlans = lazy(() => import("Pages/YessPlus/YellowPlusPlans"));
const YessPlan = lazy(() => import("Pages/YessPlus/Plans"));
const CongratulationsPlus = lazy(() => import("Pages/YessPlus/Congratulations/CongratulationsPlus"));
const SuccessScreen = lazy(() => import("Pages/SuccessScreen/SuccessScreen"));
const WillEditor = lazy(() => import("Pages/MyWill"));
const Account = lazy(() => import("Pages/UserAccount"));
const SignupAndConfirm = lazy(() => import("Pages/YessPlus/SignupAndConfirm/SignupAndConfirm"));
const YellowPlus = lazy(() => import("Pages/YessPlus/YellowPlus"));
const PaymentSummary = lazy(() => import("Pages/YessPlus/PaymentSummary/paymentSummary"));
const EditProfile = lazy(() => import("Pages/UserAccount/EditProfile"));
const DesktopOnly = lazy(() => import("./Pages/DesktopOnly"));
const Dashboard = lazy(() => import("Pages/Dashboard/NewDashboard"));
const VendorDashboard = lazy(() => import("Pages/VendorDashboard/VendorDashboard"));

import Loading from "common/Loading";
import CustomAuth from "./CustomAuth";
import { useVendor } from "common/useVendor";
import { selectUserStatus } from "store/user/selectors";
import { UserStatus } from "store/user/slice";
import MyRoles from "Pages/MyRoles";
import { DeleteAccount } from "Pages/UserAccount/DeleteAccount";
// import { showToast, ToastType } from "store/toast/slice";

function App() {
  const dispatch = useTypedDispatch();
  const location = useLocation();
  const { isAcko } = useVendor();
  const userStatus = useAppSelector(selectUserStatus);
  // const userProfile = useAppSelector(selectUserProfile);
  const [searchParams] = useSearchParams();

  // const gateActive = () => {
  //   const until = Number(sessionStorage.getItem("senja:gateUntil") || 0);
  //   return !!until && Date.now() < until;
  // };
  // const justOpenedRecently = () => {
  //   const justOpenedAt = Number(sessionStorage.getItem("senja:justOpenedAt") || 0);
  //   return !!justOpenedAt && Date.now() - justOpenedAt < 2 * 60 * 1000;
  // };
  // const autoSuppressed = () => {
  //   const suppressUntil = Number(sessionStorage.getItem("senja:suppressAutoUntil") || 0);
  //   return !!suppressUntil && Date.now() < suppressUntil;
  // };
  // const isBlockedRoute = (path: string) => {
  //   const blocked = [
  //     "/login",
  //     "/payment",
  //     "/register",
  //     "/onboarding",
  //     "/payments",
  //     "/kyc",
  //     "/vendor-dashboard",
  //     "/custom-auth",
  //     "/my-will/update-location",
  //     "/my-will/will-signing",
  //   ];
  //   return blocked.some((p) => path.startsWith(p));
  // };

  // const canConsumeQueueHere = (path: string) =>
  //   path.startsWith("/congratulations") || !isBlockedRoute(path);

  // useEffect(() => {
  //   const path = location.pathname;
  //   if (!canConsumeQueueHere(path)) return;

  //   if (gateActive()) {
  //     (window as any).__senjaLog?.push(["[Senja][App] queue: blocked by gate"]);
  //     return;
  //   }
  //   if (justOpenedRecently()) {
  //     sessionStorage.removeItem("senja:pending");
  //     (window as any).__senjaLog?.push(["[Senja][App] queue: just opened, skip"]);
  //     return;
  //   }

  //   const pending = sessionStorage.getItem("senja:pending");
  //   if (pending) {
  //     (window as any).__senjaLog?.push(["[Senja][App] consuming queued popup"]);
  //     (window as any).maybeShowSenjaFromQueue?.();
  //   }
  // }, [location.pathname, dispatch]);


  // useEffect(() => {
  //   (window as any).userProfile = userProfile ?? null;
  //   console.log("[Senja][App] window.userProfile synced", {
  //     hasWills: Array.isArray(userProfile?.wills) ? userProfile?.wills.length : undefined,
  //     isActiveLast: userProfile?.wills?.[userProfile?.wills?.length - 1]?.isActive,
  //   });
  // }, [userProfile]);

  useEffect(() => {
    dispatch({ type: "INIT_SAGA_HANDLER" });
    if (navigator.userAgent.indexOf("iPhone") > -1) {
      document
        ?.querySelector("[name=viewport]")
        ?.setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1");
    }
  }, []);

  useEffect(() => {
    if (
      userStatus.includes(UserStatus.LOGGED_OUT) ||
      (userStatus.includes(UserStatus.PROFILE_LOADED) && !isAcko)
    ) {
      setTimeout(() => {
        window.$zoho.salesiq.widget?.show();
      }, 2000);
    }
  }, [isAcko, userStatus]);

  useEffect(() => {
    if (userStatus.includes(UserStatus.PROFILE_LOADED) && !isAcko) {
      window.$zoho?.salesiq?.widget?.show();
    }
  }, [location, userStatus, isAcko]);

  useEffect(() => {
    const trackedPageName = pagesList.find((page) => location.pathname.startsWith(page));
    console.log({ searchParams });
    dispatch({
      type: "LOCATION_CHANGED",
      payload: {
        pathName: location.pathname,
        trackedPageName,
        params: Object.fromEntries(searchParams),
      },
    });
  }, [location]);

  // (window as any).maybeAutoShowSenja = maybeAutoShowSenja;

  // useEffect(() => {
  //   const onBlocked = (e: any) => {
  //     const href =
  //       e?.detail?.href ||
  //       sessionStorage.getItem("senja:fallbackUrl") ||
  //       "https://senja.io/p/yellow/r/NjJUEw";

  //     (window as any).__senjaLog?.push([
  //       "[Senja][App] popup blocked; providing fallback",
  //       { href },
  //     ]);

  //     dispatch(
  //       showToast({
  //         type: ToastType.SUCCESS,
  //         message: `Quick favor? Leave a 10-sec review — click here`,
  //       })
  //     );
  //   };

  //   window.addEventListener("senja:blocked", onBlocked);
  //   return () => window.removeEventListener("senja:blocked", onBlocked);
  // }, [dispatch]);

  // useEffect(() => {
  //   const path = location.pathname;
  //   if (isBlockedRoute(path)) return;

  //   if (gateActive()) {
  //     (window as any).__senjaLog?.push(["[Senja][App] queue: blocked by gate"]);
  //     return;
  //   }
  //   if (justOpenedRecently()) {
  //     sessionStorage.removeItem("senja:pending");
  //     (window as any).__senjaLog?.push(["[Senja][App] queue: just opened, skip"]);
  //     return;
  //   }

  //   const pending = sessionStorage.getItem("senja:pending");
  //   if (pending) {
  //     dispatch(
  //       showToast({ type: ToastType.SUCCESS, message: "Senja: consuming queued popup" })
  //     );
  //   }

  //   (window as any).maybeShowSenjaFromQueue?.();
  // }, [location.pathname, dispatch]);

  // useEffect(() => {
  //   const path = location.pathname;
  //   const blocked = isBlockedRoute(path);
  //   console.log("[Senja][App] maybeAutoShowSenja route check", {
  //     path,
  //     blocked,
  //   });
  //   if (blocked) return;

  //   if (gateActive()) {
  //     (window as any).__senjaLog?.push(["[Senja][App] auto: blocked by gate"]);
  //     return;
  //   }
  //   if (autoSuppressed()) {
  //     const until = Number(sessionStorage.getItem("senja:suppressAutoUntil") || 0);
  //     (window as any).__senjaLog?.push(["[Senja][App] auto: suppressed", { until }]);
  //     return;
  //   }

  //   maybeAutoShowSenja(
  //     {
  //       name: userProfile?.fullName ?? "",
  //       email: userProfile?.email ?? "",
  //       phone: userProfile?.phoneNumber ?? "",
  //       url: window.location.href,
  //     },
  //     {
  //       randomChance: 0.1,
  //       cooldownDays: 14,
  //       maxShowsPer30Days: 3,
  //     }
  //   );
  // }, [location.pathname, userProfile?.fullName, userProfile?.email, userProfile?.phoneNumber]);

  if (typeof window !== 'undefined' && !(window as any).__navLoggerPatched) {
    (window as any).__navLoggerPatched = true;

    (['pushState', 'replaceState'] as const).forEach((fn) => {
      const orig = history[fn];
      // @ts-ignore
      history[fn] = function (...args) {
        const url = args?.[2];
        console.groupCollapsed(`[NAV] history.${fn} -> ${url}`);
        console.log('args:', args);
        console.trace('who triggered navigate?'); // <-- click this to jump to file/line
        console.groupEnd();
        // @ts-ignore
        return orig.apply(this, args);
      }
    });

    window.addEventListener('popstate', (e) => {
      console.groupCollapsed('[NAV] popstate');
      console.log('state:', e.state);
      console.trace('back/forward triggered here');
      console.groupEnd();
    });
  }


  return (

    <ThemeProvider theme={theme}>
      <div className="App">
        <GlobalStyle />
        <Toast />
        <ScrollToTop>
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route path={Pages.DESKTOP_ONLY} element={<DesktopOnly key={location.key} />} />
              <Route
                path={Pages.LOGIN}
                element={<RegistrationAndLogin forLogin={true} key={location.key} />}
              />
              <Route
                path={Pages.REGISTER}
                element={<Navigate to={Pages.LOGIN} replace />}
              />
              <Route path={Pages.HOME} element={<Home key={location.key} />} />
              <Route path={Pages.LEGAL} element={<LegalTerms key={location.key} />} />
              <Route path={Pages.PRIVACY_POLICY} element={<PrivacyPolicy key={location.key} />} />
              <Route path={Pages.PRICING} element={<YellowPlusPlans key={location.key} />} />
              <Route path={Pages.YELLOW_PLUS_BASIC} element={<YellowPlusPlans key={location.key} />} />
              <Route path={Pages.YELLOW_PLUS} element={<YellowPlus key={location.key} />} />

              {/* BEGIN: Moved out of private because of routing cases */}
              <Route path={Pages.MY_CART} element={<YessPlan key={location.key} />} />
              <Route path={Pages.MEMBER_DETAILS} element={<SignupAndConfirm key={location.key} />} />
              {/* END */}

              <Route path={Pages.CUSTOM_AUTH} element={<CustomAuth key={location.key} />} />
              <Route path={Pages.PAYMENT} element={<NewPayments />} />

              <Route element={<PrivateRoute />}>
                <Route path={Pages.DASHBOARD} element={<Dashboard key={location.key} />} />
                <Route path={Pages.VENDOR_DASHBOARD} element={<VendorDashboard key={location.key} />} />
                <Route path={Pages.MY_ACCOUNT} element={<Account key={location.key} />} />
                <Route path={Pages.EDIT_PROFILE} element={<EditProfile key={location.key} />} />
                <Route path={Pages.DELETE_ACCOUNT} element={<DeleteAccount />} />
                <Route path={Pages.CONGRATULATIONS} element={<CongratulationsPlus key={location.key} />} />
                <Route path={Pages.SUCCESS_SCREEN} element={<SuccessScreen />} />
                <Route path={Pages.CHECKOUT} element={<PaymentSummary key={location.key} />} />
                <Route path={Pages.ONBOARDING} element={<OnBoarding key={location.key} />} />

                <Route path={Pages.WILL_EDITOR} element={<WillEditor key={location.key} />} />
                <Route path={Pages.PERSONAL_DETAILS} element={<WillEditor key={location.key} />} />
                <Route path={Pages.MY_ESTATE} element={<WillEditor key={location.key} />} />
                <Route path={Pages.MY_BENEFICIARIES} element={<WillEditor key={location.key} />} />
                <Route path={Pages.ASSET_DISTRIBUTION} element={<WillEditor key={location.key} />} />
                <Route path={Pages.WILL_EXECUTOR} element={<WillEditor key={location.key} />} />
                <Route path={Pages.GUARDIANS} element={<WillEditor key={location.key} />} />
                <Route path={Pages.MY_WITNESSES} element={<WillEditor key={location.key} />} />

                <Route path={Pages.KYC} element={<KYCVerification key={location.key} />} />
                <Route path={Pages.MY_ROLES} element={<MyRoles key={location.key} />} />
                <Route path={Pages.MY_WILL} element={<MyWill key={location.key} />} />
                <Route path={Pages.MY_WILL_SIGNING_VIDEO} element={<MyWill key={location.key} />} />
                <Route path={Pages.MY_WILL_UPDATE_LOCATION} element={<MyWill key={location.key} />} />
                <Route path={Pages.MY_WILL_SHIPPING_AND_COURIER} element={<ShippingFlow key={location.key} />} />
                <Route path="/shipping-flow" element={<ShippingFlow key={location.key} />} />
              </Route>
            </Routes>
          </Suspense>
        </ScrollToTop>
      </div>
    </ThemeProvider>
  );
}

export default App;
